// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__3dxqX","boxTitle":"Qualiphy_boxTitle__38hvo","box":"Qualiphy_box__1LR9r","toggleWrap":"Qualiphy_toggleWrap__2J-sN"};